import cookie from 'cookie';
import env from 'config/env';

const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.20.0.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const config = {
  host: 'pricelist.qlik.com',
  secure: true,
  port: 443,
  prefix: env === 'local' ? 'anonymous' : 'jwt',
  appId: env === 'production' ? 'e852ef7e-dd0d-4d7a-b518-b36d58b6d2cc' : '24b3bda1-b55e-45c5-bbbc-8a5adaada69d',
};


// e852ef7e-dd0d-4d7a-b518-b36d58b6d2cc : Pricing App New
// 24b3bda1-b55e-45c5-bbbc-8a5adaada69d : Pricing App New Staging

// 3961e19c-912d-48b8-b4d4-2a32d7501b9a : Pricing App
// 7542e0c0-dd7e-4f4d-81ce-420cc071e7ff : Pricing App Staging


const url = SenseUtilities.buildUrl(config);

export default new Promise(async (resolve) => {
  if (env !== 'local') {
    const cookies = cookie.parse(document.cookie);
    const jwt = cookies.pricelist;
    const qpsUserReq = await fetch('https://pricelist.qlik.com/jwt/qps/user', {
      headers: {
        'Content-Type': 'application/json',
        'X-Qlik-XrfKey': 'abcdefghijklmnop',
        Authorization: `Bearer ${jwt}`,
      },
      credentials: 'include',
    });

    console.log('qpsUserReq -> ', qpsUserReq);

    const qpsUserRes = await qpsUserReq;

    console.log('qpsUserRes -> ', qpsUserRes);
    if (qpsUserRes.status === 400) return;
  }

  const global = await enigma.create({ schema, url }).open();
  const qDoc = await global.openDoc(config.appId);
  const maxMonthYear = await qDoc.evaluateEx('Date(only([Default Date]), \'MMMM YYYY\')');
  const monthYearField = await qDoc.getField('[Month Year]');
  const currencyField = await qDoc.getField('Currency');
  const serviceCurrencyField = await qDoc.getField('Service_Currency');
  await monthYearField.select(maxMonthYear.qText);
  // await monthYearField.lock();
  await currencyField.select('USD');
  // await currencyField.lock();
  await serviceCurrencyField.select('USD');
  // await serviceCurrencyField.lock();
  resolve(qDoc);
});
